import { createApp, ref } from 'vue'
import App from './App.vue'
import router from './router.js'
import {confirm , loading, error, clickOutside, mousedownOutside} from 'eduair-shared'
let app;

if (!app) {
    app = createApp(App).use(router).use(confirm).use(loading).use(error)

    app.directive('click-outside', clickOutside)
    app.directive('mousedown-outside', mousedownOutside)

    app.config.globalProperties.$osVersion = ref('000000');
    app.mixin({
        methods: {
          updateOsVersion(newVersion) {
            this.$osVersion.value = newVersion; // Update the ref value
          }
        }
    });

    app.mount('#app')
}
